exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".custom-text{font-size:50 px;line-height:26 px;font-family:Georgia;max-width:30 px}.custom-title{padding-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/components/custom/title/Title.scss
// module id = 72
// module chunks = 0